import { fetchQuery, graphql } from "relay-runtime"
import {
  betterDocAnamnesisInfoSchemasQuery,
  betterDocAnamnesisInfoSchemasQuery$data,
} from "@/modules/admin/better-doc/services/__generated__/betterDocAnamnesisInfoSchemasQuery.graphql"
import { RelayEnvironment } from "@/relay-environment"

const query = graphql`
  query betterDocAnamnesisInfoSchemasQuery {
    de_betterDocAnamnesisInfoSchemas {
      status
      httpStatusCode
      errorReason
      exchangeId
      schemas {
        name
        version
        status
        selector {
          path
          value
        }
        attributes {
          name
          valueType
          description
          requirementJson
          action
          source
          isNullable
          allowedValuesJson
          itemDefinitionJson
        }
      }
    }
  }
`

export type BetterDocAnamnesisInfoSchemasResult =
  betterDocAnamnesisInfoSchemasQuery$data["de_betterDocAnamnesisInfoSchemas"]

export type BetterDocAnamnesisInfoSchema = BetterDocAnamnesisInfoSchemasResult["schemas"][number]

export const fetchBetterDocAnamnesisInfoSchemas = (): Promise<BetterDocAnamnesisInfoSchemasResult> =>
  fetchQuery<betterDocAnamnesisInfoSchemasQuery>(RelayEnvironment, query, {}, { fetchPolicy: "network-only" })
    .toPromise()
    .then((response) => {
      if (!response) {
        throw new Error("BetterDoc returned no response")
      }

      return response.de_betterDocAnamnesisInfoSchemas
    })
